import { useLanguage } from '../contexts/LanguageContext';
import { Check, Sparkles } from 'lucide-react';

export const LeadHookSection = () => {
  const { t, isRTL } = useLanguage();
  const benefits = t('leadHook.benefits');

  return (
    <section className="py-12 sm:py-16 md:py-32 bg-background" data-testid="lead-hook-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-brand/10 text-brand px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4 sm:mb-6">
            <Sparkles className="w-4 h-4 sm:w-5 sm:h-5" />
            <span className="font-medium text-sm sm:text-base">{t('leadHook.badge')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-primary">
            {t('leadHook.title')}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-6 sm:p-8 md:p-12">
            <ul className="space-y-4 sm:space-y-6">
              {Array.isArray(benefits) && benefits.map((benefit, index) => (
                <li 
                  key={index} 
                  className={`flex items-start gap-3 sm:gap-4 ${isRTL ? 'flex-row-reverse text-right' : ''}`}
                  data-testid={`benefit-${index}`}
                >
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-green-100 rounded-full flex items-center justify-center">
                    <Check className="w-4 h-4 sm:w-5 sm:h-5 text-green-600" />
                  </div>
                  <span className="text-base sm:text-lg text-slate-700 font-medium">{benefit}</span>
                </li>
              ))}
            </ul>

            <div className="mt-6 sm:mt-10 pt-6 sm:pt-8 border-t border-slate-100 text-center">
              <p className="text-lg sm:text-xl font-semibold text-primary" data-testid="lead-hook-cta">
                {t('leadHook.cta')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
